module.exports = "https://coursera_assets.s3.amazonaws.com/images/ed0c31442953eabf98fb1565790ff5fd.png";